import to from 'await-to-js';
import * as apis from '@/api/interface/article';

export default {
  namespaced: true,
  state: () => ({
    articleList: undefined, //文章 - 列表
    articleTypes: [], //文章 - 分类选项
  }),
  mutations: {
    update(state, payload) {
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key];
      });
    },
  },
  actions: {
    // 获取文章列表
    async getArticleList(ctx, payload = {}) {
      const [err, res] = await to(apis.getArticleList(payload));
      ctx.commit('update', {
        articleList: !err && res && res.code === '000000' ? res.data : undefined,
      });
      return res;
    },
    // 获取文章分类
    async getArticleTypes(ctx) {
      const [err, res] = await to(apis.getArticleTypes());
      ctx.commit('update', {
        articleTypes: !err && res && res.code === '000000' && Array.isArray(res.data) ? res.data : [],
      });
      return res;
    },
    // 获取文章详情
    async getArticleDetail(_ctx, payload = {}) {
      const [, res] = await to(apis.getArticleDetail(payload));
      return res;
    },
    // 新增文章
    async createArticle(_ctx, payload = {}) {
      const [, res] = await to(apis.createArticle(payload));
      return res;
    },
    // 修改文章
    async updateArticle(_ctx, payload = {}) {
      const [, res] = await to(apis.updateArticle(payload));
      return res;
    },
    // 发布文章
    async publishArticle(_ctx, payload = {}) {
      const [, res] = await to(apis.publishArticle(payload));
      return res;
    },
    // 下架文章
    async offlineArticle(_ctx, payload = {}) {
      const [, res] = await to(apis.offlineArticle(payload));
      return res;
    },
    // 上传文章图片
    async uploadArticleImage(_ctx, payload = {}) {
      const [, res] = await to(apis.uploadArticleImage(payload));
      return res;
    },
  },
};
